'use client';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FAQSection } from './FAQSection';

import { ScFAQContainer } from './styled';

export interface IFAQItem {
  question: string;
  answer: string;
}

interface IFAQContainerProps {
  items: IFAQItem[];
}

export const FAQContainer: FC<IFAQContainerProps> = ({ items }) => {
  const { t } = useTranslation('common');
  return (
    <ScFAQContainer id="faq-container">
      <p className="title">{t('faqContainerTitle')}</p>
      <FAQSection items={items} />
    </ScFAQContainer>
  );
};
